// Helper function to remove a nested property from an object
export const deleteNestedProperty = ({ storeObject, path }) => {
  if (path.length === 0) return undefined
  const [first, ...rest] = path
  if (!storeObject[first]) return storeObject
  if (rest.length === 0) {
    const { [first]: _, ...newObject } = storeObject
    return newObject
  }
  return {
    ...storeObject,
    [first]: deleteNestedProperty({
      storeObject: storeObject[first],
      path: rest
    })
  }
}

// Helper function for setting nested properties in an object
export const setNestedProperty = ({ storeObject, path, value }) => {
  if (path.length === 0) return value
  const [first, ...rest] = path
  return {
    ...storeObject,
    [first]: setNestedProperty({
      storeObject: storeObject[first] || {},
      path: rest,
      value
    })
  }
}

// Helper function to create a path for results based on survey name, group name, and attribute segment
export const pathForResults = ({ surveyName, groupName, attributeSegment }) => {
  const path = [surveyName, groupName]
  if (attributeSegment && attributeSegment.name !== 'all') {
    path.push(attributeSegment.attributeName, attributeSegment.segmentName)
  } else {
    path.push('all')
  }
  return path
}
